import axiosClient from './axiosClient';

export async function applyToJob({ postId, body, resumeFile }) {
  const formData = new FormData();
  if (postId != null) {
    formData.append('post_id', String(postId));
  }
  if (body) {
    formData.append('body', body);
  }
  if (resumeFile) {
    formData.append('resume[filename]', resumeFile, resumeFile.name || 'cv.pdf');
  }

  const config = {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  };

  const response = await axiosClient.post('/threads', formData, config);
  return response.data;
}
